import * as React from 'react';
import { useState, useEffect } from 'react';
import { PopularProducts } from './SearchHeaderBlocks/PopularProducts';
import shopify from 'frontend/js/shopify';
import api from 'frontend/js/api';

import { useSearchHeader } from '@src/contexts/SearchHeaderContext';

// Hardcoded limit for popular products
const POPULAR_PRODUCTS_LIMIT = 10;

interface PopularProductsBlockProps {
  settings?: {
    popular_products_title?: string;
    tile_type?: string;
    popular_products_collection?: any;
    collection?: any;
    [key: string]: any;
  };
  className?: string;
  searchQuery?: string;
}

export const PopularProductsBlock: React.FC<PopularProductsBlockProps> = ({ settings, className = '' }) => {
  const blockSettings = settings?.settings?.block_settings || settings || {};
  const [popularProducts, setPopularProducts] = useState(settings?.settings?.popular_products || []);

  // Use SearchHeaderContext to check if there are product results
  const { products, totalResults } = useSearchHeader();
  // Show popular products when there are no search product results
  const showPopularProducts = !products || products.length === 0;

  const handleViewMore = () => {
    const collectionHandle = blockSettings.collection || blockSettings.popular_products_collection;
    if (collectionHandle) {
      window.location.href = `/collections/${collectionHandle}`;
    } else {
      window.location.href = '/collections/all';
    }
  };

  return (
    <>
      {showPopularProducts && (
        <div className={`w-full ${className}`}>
          <PopularProducts
            title={blockSettings.popular_products_title || blockSettings.title || 'Popular Products'}
            products={popularProducts}
            settings={settings}
            onViewMore={handleViewMore}
          />
        </div>
      )}
    </>
  );
};
